import { createAsyncThunk } from '@reduxjs/toolkit';
import { newItemEquipment } from 'types';
import { machineService } from '../../services/index';

export const getDataStoreFieldMachine = createAsyncThunk<any, { appId: string; dataStoreId: string }>(
  'register/getDataStoreFieldMachine',
  async (params) => {
    const response = await machineService.getDataStoreFieldMachine(params);
    return response;
  },
);

export const getDataStoreFieldEquipment = createAsyncThunk<any, { appId: string; dataStoreId: string }>(
  'register/getDataStoreFieldEquipment',
  async (params) => {
    const response = await machineService.getDataStoreFieldEquipment(params);
    return response;
  },
);

export const equipmentNewItem = createAsyncThunk<any, newItemEquipment>('register/Equipment', async (params) => {
  const machineItem = params.machine
    ? params.machine.map((item) => {
        return {
          operation: 1,
          link_to_parent: true,
          item: { ...item, lease_contract_id: params.item.lease_contract_id },
        };
      })
    : [];
  const newParam = { ...params, related_ds_items: machineItem };
  const { data } = await machineService.newEquipment(newParam);
  return data;
});
